import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { ToasterModule, ToasterService } from 'angular2-toaster';

import { ApiService } from '../../services/api.service';

@Component({
	selector: 'app-add-company',
	templateUrl: './add-company.component.html',
	styleUrls: ['./add-company.component.css']
})

export class AddCompanyComponent implements OnInit {

	private toasterService: ToasterService;
	file: File;
	fullname = "";
	username = "";
	email = "";
	password = "";
	activeUsersCount = "";
	billingCycleDate = 1;
	isTestingCompany: boolean = false;
	language = "en";
	error_username = "";
	error_name = "";
	error_email = "";
	error_password = "";
	error_activeUsersCount = "";
	error_language= "";
	base64textString = "";

	constructor(private apiService: ApiService, toasterService: ToasterService) {
		this.toasterService = toasterService;
	}

	validateEmail(email) {
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,9})+$/.test(email)) {
			return true;
		}
		// alert("You have entered an invalid email address!")
		return false;
	}

	ngOnInit() {
		if (!sessionStorage.getItem('access_token_nv_admin')) {
			window.open("/login", "_self");
		}
	}

	fileSelected(imageData) {
		this.file = imageData;
	}

	languageChange(lang) {
		if (lang) this.language = lang.target.value;
	}

	addCompany() {

		if (this.username == "") {
			this.error_username = "required";
		} else {
			this.error_username = "";
		}

		if (this.fullname == "") {
			this.error_name = "required";
		} else {
			this.error_name = "";
		}

		if (this.email == "") {
			this.error_email = "required";
		} else if (!this.validateEmail(this.email)) {
			this.error_email = "invalid";
		} else {
			this.error_email = "";
		}

		if (this.activeUsersCount == "") {
			this.error_activeUsersCount = "required";
		} else {
			this.error_activeUsersCount = "";
		}

		if (this.password == "") {
			this.error_password = "required";
		} else {
			this.error_password = "";
		}

		if (this.language == "") {
			this.error_language = "required";
		} else {
			this.error_language = "";
		}
		

		if (this.fullname != "" && this.username != "" && this.email != "" && this.activeUsersCount != "") {
			let formData: FormData = new FormData();
			formData.append('companyLogo', this.file);
			formData.append('name', this.fullname);
			formData.append('userName', this.username);
			formData.append('email', this.email);
			formData.append('activeUsersCount', this.activeUsersCount);
			formData.append('billingCycleDate', this.billingCycleDate.toString());
			formData.append('isTestingCompany', this.isTestingCompany.toString());
			formData.append('password', this.password.toString());
			formData.append('language', this.language.toString());
			this.apiService.addCompany(formData).subscribe((data:any) => {
				this.toasterService.pop('success', data.message);
				window.open("/home", "_self");
			},
				error => {
					if (error.statusText == "Unauthorized") {
						// this.toasterService.pop('error', 'Session Expired', 'Please login again');
						window.open("/logout", "_self");
					} else  this.toasterService.pop('error', error.error.message);
				});
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/components/add-company/add-company.component.ts